import { Controller } from "stimulus"
import consumer from "channels/consumer"

export default class extends Controller {
  static targets = []

  connect(){
    this.subscription = consumer.subscriptions.create({ channel: "BlastStatusChannel", id: this.data.get("id")}, {
      connected: this._connected.bind(this),
      disconnected: this._disconnected.bind(this),
      received: this._received.bind(this)
    })
  }

  disconnect(){
    consumer.subscriptions.remove(this.subscription)
  }

  _connected(){

  }

  _disconnected(){

  }

  _received(data){
    if (data.status === "content_pending") {
      $("#new-generating-modal").modal('show')
    } else if (data.status === "content_ready") {
      location.href = this.data.get("path");
    } else if (data.status === "content_failed") {
      $("#new-generating-modal").modal('hide')
      toastr.error("Something went wrong generating the content.")
    }
  }

}
